<template >
    <div class="campaignListContainer">
        <b-breadcrumb class="breadCrumb">
            <b-breadcrumb-item href="#home" @click="goBackToCampaignList">
                
              <b-icon icon="card-list"></b-icon>

                Campaigns List
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="flagUpdate" active>Update</b-breadcrumb-item>
            <b-breadcrumb-item v-if="flagCreate" active>Create</b-breadcrumb-item>

        </b-breadcrumb>
        
        <div class="buttonContainer">
        <b-button variant="success" @click="redirectUpdate" class="EditButton">
        Edit
        </b-button>
        <b-button variant="danger" @click="showModal" class="DeleteButton">
        Delete
        </b-button>
        </div>
        <div class="card bg-dark border-0 tableContainer">
            <b-table stacked :items="result" striped class="table" :fields="fields">
                <template #cell(CampaignVideos)="data">
                    <div class="videosContainer ">
                        <div class="col-md-2   videoColumn " v-for="video in Videos">
                            <div class="video-image ">
                                <img :src="video.thumbnail" :alt="video.title" width="100%">
                            </div>
                            <div class="video-title">{{ video.title }}</div>
                        </div>

                    </div>

                </template>
            </b-table>
        </div>

    </div>
</template>
<script>

import API from "../api.js";
import router from "@/router";
export default{
data(){
    return{
 id:this.$route.params.id,
 result:[],
 fields:['id','tenant_id','name','start_date','end_date','redirect_url','CampaignVideos'],
 tempFlag:false,
 fieldsVideoTable:[{key:"one",label:" "}],
 Videos:[]

}
},
methods:{
    redirectUpdate(){
        this.$router.push({
            path:`Update/${this.id}`
        })
    },
    async getCampaignById(id){
        let res= API.getCampaignById(id)
        var result={}
        await res.then((result1)=>{console.log(result1)
        result=result1
        })
        this.result.push( result.data)      //[{campaigndetails}] this will help theresult to display in form of table directly,
        delete this.result[0].is_deleted
        delete this.result[0].created_at
        delete this.result[0].updated_at
        delete this.result[0].config       
        this.Videos=this.result[0].CampaignVideos
   },
    makeToast(variant = null, content) {
        this.$bvToast.toast(content, {
            title: "Message",
            variant: variant,
            solid: true,

        })
    },
    showModal(){
        this.$bvModal.msgBoxConfirm('Are you sure?',{
            title: 'Please Confirm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
          .then(value => {
            
            if(value){
                this.deleteCamp(this.id)
                this.goBackToCampaignList()
            }


          })},
        
    async deleteCamp(id) {
        console.log("Id is " + id);
        let res = await API.deleteCampaign(id)
        console.log(res);

        if (res.status === 200) {
                this.makeToast("success", "Campaign Deleted Succesfully")
                

        } 
        else if (res.status == 500){
                console.log("Unable to delete campaign");
                this.makeToast("danger", "Unable to delete campaign")    
        }
        else {
                this.makeToast("danger", "Could not Delete Campaign")

        }

        },
        async goBackToCampaignList() {
            //router.go(-1)
            this.$router.push('/admin/campaign')
        }

},
mounted(){
    this.getCampaignById(this.id)
}
}
</script>
<style>
.modalVideos{
    width: 50%;
}
</style>
<style scoped>

.videosContainer{
    padding: 10px;
    display: flex;
    flex-direction:row ;
    flex-wrap: wrap;
}
.tableContainer{
    padding: 10px;
    margin: 10px;
}
.EditButton{
    margin: 5px
}
.DeleteButton{
    margin: 5px
}
.buttonContainer{
    margin: 10px;
}
</style>